import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { BsPersonFill } from 'react-icons/bs';
import { BASE_URL, USER_URL } from '../../constant/api';
import { useParams, useNavigate } from 'react-router-dom';

function SubAdminCustomerView() {
  const [products, setProducts] = useState([]);
  const [customerData, setCustomerData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const { customerId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCustomerData = async () => {
      try {
        const response = await USER_URL.get(`/accounts/subadmin/customers/${customerId}/`);
        setCustomerData(response.data?.data || null);
      } catch (error) {
        setCustomerData(null);
        console.error('Error fetching customer data:', error);
      }
    };

    const fetchProductData = async () => {
      try {
        const response = await USER_URL.get(`/products/`);
        setProducts(response.data?.Data || []);
      } catch (error) {
        setProducts([]);
        console.error('Error fetching products:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchCustomerData();
    fetchProductData();
  }, [customerId]);

  // Dummy customer data (if API fails or no data available)
   const dummyCustomer = {
    username: "John Doe",
    email: "johndoe@example.com",
    mobile_number: "+1234567890",
    city: "New York",
    address: "123 Main St",
    post_code: "10001",
    address2: "Apt 4B",
  };

  // Dummy products (if no products found)
  const dummyProducts = [
    {
     id: 1,
      name: "Sample Product 1",
      product_images: [{ image: "https://via.placeholder.com/100" }],
     },
    {
       id: 2,
       name: "Sample Product 2",
      product_images: [{ image: "https://via.placeholder.com/100" }],
    },
   ];

  // Use dummy data if no actual data is available
  const displayCustomer = customerData || dummyCustomer;
  const displayProducts = products.length > 0 ? products : dummyProducts;

  if (loading) return <div className="text-center py-10 text-gray-500">Loading...</div>;
  if (error) return <div className="text-center py-10 text-red-500">{error}</div>;

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      {/* Header */}
      <h1 className="mb-5 text-green-500 font-semibold">Sub Admin - Customer View</h1>

      {/* Profile Section */}
      <div className="flex items-center space-x-6 mb-8">
        <div className="w-24 h-24 bg-yellow-300 rounded-full border border-gray-300 flex items-center justify-center">
          <BsPersonFill className="text-gray-500 text-7xl" />
        </div>
        <h2 className="text-3xl font-bold text-gray-800">
          {displayCustomer.username}
        </h2>
      </div>

      {/* Personal Info Section */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10">
        <div>
          <h2 className="text-2xl font-bold mb-4">Personal Info</h2>
          <div className="space-y-4">
            <div className="p-4 bg-white border rounded-lg shadow-sm">
              <span className="block text-sm font-medium text-gray-600 mb-1">Name</span>
              <p className="text-lg font-semibold text-gray-800">{displayCustomer.username}</p>
            </div>
            <div className="p-4 bg-white border rounded-lg shadow-sm">
              <span className="block text-sm font-medium text-gray-600 mb-1">Email</span>
              <p className="text-lg font-semibold text-gray-800">{displayCustomer.email}</p>
            </div>
            <div className="p-4 bg-white border rounded-lg shadow-sm">
              <span className="block text-sm font-medium text-gray-600 mb-1">Phone Number</span>
              <p className="text-lg font-semibold text-gray-800">{displayCustomer.mobile_number}</p>
            </div>
          </div>
        </div>

        {/* Address Section */}
        <div>
          <div className="space-y-4 mt-12">
            <div className="p-4 bg-white border rounded-lg shadow-sm">
              <span className="block text-sm font-medium text-gray-600 mb-1">Address</span>
              <p className="text-lg font-semibold text-gray-800">
                {`${displayCustomer.address}, ${displayCustomer.city},${displayCustomer.state}, ${displayCustomer.country}  - ${displayCustomer.post_code}`}
              </p>
            </div>
            <div className="p-4 bg-white border rounded-lg shadow-sm">
              <span className="block text-sm font-medium text-gray-600 mb-1">Address 2</span>
              <p className="text-lg font-semibold text-gray-800">
                {displayCustomer.address2 || "No secondary address available"}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Customer Most Purchased Products Section */}
      <div>
        <h2 className="text-2xl font-bold mb-4 mt-16">Customer Most Purchased Products</h2>

        {/* Products List */}
        <div className="overflow-x-auto bg-gray-50 p-2">
          <div className="flex space-x-4">
            {displayProducts.map((product) => (
              <div
                key={product.id}
                className="p-4 min-w-[150px] bg-white border rounded-lg shadow-sm flex flex-col items-center hover:shadow-lg hover:border-green-400 transition-all"
              >
                <img
                  src={product.product_images?.[0]?.image || 'https://via.placeholder.com/100'}
                  alt={product.name || 'Product'}
                  className="mb-2 w-24 h-24 object-cover rounded transition-transform transform hover:scale-105"
                />
                <p className="text-sm font-semibold text-gray-800 text-center">
                  {product.name || 'Unnamed Product'}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default SubAdminCustomerView;

